<template>
  <div id="home-main">
    <el-card class="content">
      <searchHead ref="searchHead"/>
    </el-card>

    <el-card class="mapCard content contentExceptFir">
      <mapFocus ref="childMap"/>
    </el-card>

    <div class="contentSecPart">
      <el-card v-if="volumeLeftShow" :class="{ volumeLeftShow: volumeLeftShow, volumeLeftRight: volumeLeftRight }"
               class="content contentExceptFir">
        <volumeLeft ref="volumeLeft"/>
      </el-card>
      <el-card v-if="volumeRightShow" :class="{ volumeRightShow: volumeRightShow, volumeRightLeft: volumeRightLeft, }"
               class="content contentExceptFir">
        <volumeRight ref="volumeRight"/>
      </el-card>
    </div>

    <el-card class="content contentExceptFir">
      <div class="elementhead">
        <div class="tarGeta">
          <span class="seaTar">Industry public opinion trend</span>
          <span class="seaTar1">TOP5 industry public opinion trends（from April 2023 to April 2024）</span>
          <div class="switch">
            <i :class="{ switchSelected: bool.isIPOTChart }" class="el-icon-picture-outline"
               @click="bool.isIPOTChart = true"/>
            <i :class="{ switchSelected: !bool.isIPOTChart }" class="el-icon-s-grid"
               @click="bool.isIPOTChart = false"/>
            <i class="el-icon-download" @click="downLoadIPOT"/>
            <el-popover v-model="visiblepopover" placement="bottom-end" popper-class="popoverStyle" trigger="click"
                        width="450">
              <div class="popoverLine"/>
              <div class="popoverSelectGroup">
                <span>Nation</span>
                <el-select v-model="data.IPOTrend.mediaCountries" class="popoverSelect" filterable multiple
                           placeholder="please select" size="mini">
                  <el-option v-for="item in paramForm.countries" :key="item" :label="item" :value="item"/>
                </el-select>
              </div>
              <div class="popoverSelectGroup">
                <span>Industry</span>
                <el-select v-model="data.IPOTrend.industries" :multiple-limit="5" class="popoverSelect" filterable
                           multiple placeholder="please select" size="mini">
                  <el-option v-for="item in paramForm.industries" :key="item" :label="item" :value="item"/>
                </el-select>
              </div>
              <div class="popoverSelectGroup">
                <span>Time</span>
                <el-date-picker v-model="data.IPOTrend.pubTime" :clearable="false"
                                :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions"
                                class="popoverSelect"
                                end-placeholder="end date" range-separator="——" size="mini"
                                start-placeholder="start date"
                                type="daterange"/>
              </div>
              <div class="industry-chart-button">
                <el-button icon="el-icon-close" size="mini" type="info" @click="visiblepopover = false"/>
                <el-button icon="el-icon-check" size="mini" type="primary" @click="getIndustryPublicOpinionTrend"/>
              </div>
              <div slot="reference" class="btnSearch">
                <img alt="" src="@/views/brand/assets/img/search.png"/>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="charts-margin">
        <div ref="IPOTChart">
          <elementView v-show="bool.isIPOTChart" ref="elementViewChild"/>
        </div>
        <div v-show="!bool.isIPOTChart" class="charts-table">
          <div ref="IPOTTable" class="downloadTable">
            <el-table :data="result.IPOTrend.tableData" border height="400">
              <el-table-column align="center" header-align="center" label="industry" prop="industry"
                               show-overflow-tooltip width="150"/>
              <el-table-column v-for="(item, key) in result.IPOTrend.dates" :key="key" :label="item" :prop="item"
                               align="center" show-overflow-tooltip width="150"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-card>
    <!-- echarts第二部分 -->
    <el-card class="content contentExceptFir contentLast">
      <div class="elementhead">
        <div class="tarGeta">
          <span class="seaTar">Industry dynamism</span>
          <span class="seaTar1">TOP10 of national industry dynamism（from April 2023 to April 2024）</span>
          <div class="switch">
            <i :class="{ switchSelected: bool.isIDChart }" class="el-icon-picture-outline"
               @click="bool.isIDChart = true"/>
            <i :class="{ switchSelected: !bool.isIDChart }" class="el-icon-s-grid" @click="bool.isIDChart = false"/>
            <i class="el-icon-download" @click="downLoadID"/>
            <el-popover v-model="visiblepopoversec" placement="bottom-end" popper-class="popoverStyle" trigger="click"
                        width="450">
              <div class="popoverLine"/>
              <div class="popoverSelectGroup">
                <span>Nation</span>
                <el-select v-model="data.industryDynamism.mediaCountries" :multiple-limit="10" class="popoverSelect"
                           filterable multiple placeholder="please select" size="mini">
                  <el-option v-for="item in paramForm.countries" :key="item" :label="item" :value="item"/>
                </el-select>
              </div>
              <div class="popoverSelectGroup">
                <span>Time</span>
                <el-date-picker v-model="data.industryDynamism.pubTime" :clearable="false"
                                :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions"
                                class="popoverSelect"
                                end-placeholder="end date" range-separator="——" size="mini"
                                start-placeholder="start date"
                                type="daterange"/>
              </div>
              <div class="dynamism-button">
                <el-button icon="el-icon-close" size="mini" type="info" @click="visiblepopoversec = false"/>
                <el-button icon="el-icon-check" size="mini" type="primary" @click="getIndustryDynamism"/>
              </div>
              <div slot="reference" class="btnSearch">
                <img alt="" src="@/views/brand/assets/img/search.png"/>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="dynamism-charts">
        <div ref="IDChart">
          <elementView1 v-show="bool.isIDChart" ref="elementView1Child"/>
        </div>
        <div v-show="!bool.isIDChart" style="overflow: auto; height: 100%">
          <div ref="IDTable" class="downloadTable">
            <el-table :data="result.industryDynamism.table.tableData" border height="400" style="width: 100%">
              <el-table-column align="center" label="nation" prop="country" show-overflow-tooltip width="150"/>
              <el-table-column align="center" header-align="center" label="Industry dynamism" prop="dynamism"
                               show-overflow-tooltip width="152"/>
              <el-table-column v-for="(item, key) in result.industryDynamism.table.industries" :key="key" :label="item"
                               :prop="item" align="center" show-overflow-tooltip width="150"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import searchHead from '@/views/brand/merge/searchHead.vue'
import elementView from '@/views/brand/merge/element.vue' // 折线
import elementView1 from '@/views/brand/merge/element1.vue' // 柱状图
import volumeLeft from '@/views/brand/merge/volumeLeft.vue'
import volumeRight from '@/views/brand/merge/volumeRight.vue'
import mapFocus from '@/views/brand/merge/mapFocus.vue'
import request from '@/views/brand/utils/request'
import html2canvas from 'html2canvas'
import {getAuthApi, getToken, setAuthApi, setToken} from '@/views/brand/utils/auth'

export default {
  components: {
    searchHead,
    elementView,
    elementView1,
    volumeLeft,
    volumeRight,
    mapFocus
  },
  data() {
    return {
      bool: {
        isIPOTChart: true,
        isIDChart: true,
        IPOVLoading: false,
        EPOVLoading: false,
        IPOTLoading: false,
        IDLoading: false
      },
      param: {},
      data: {
        IPOTrend: {mediaCountries: [], industries: [], pubTime: []},
        industryDynamism: {mediaCountries: [], pubTime: []}
      },
      result: {
        IPOTrend: {dates: [], lineData: [], industries: [], tableData: []},
        industryDynamism: {
          lineData: {countries: [], lineData: []},
          pieData: {countries: [], pieData: [], checkedCountry: ''},
          table: {industries: [], tableData: []}
        }
      },
      paramForm: {countries: [], industries: [], companies: []},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().setHours(23, 59, 59, 999)
        }
      },
      volumeLeftShow: true,
      volumeRightShow: true,
      volumeLeftRight: true,
      volumeRightLeft: true,
      visiblepopover: false,
      visiblepopoversec: false,
      permission: []
    }
  },
  watch: {
    visiblepopoversec() {
      if (this.visiblepopoversec && this.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        setTimeout(() => {
          this.visiblepopoversec = false
        }, 1)
      }
    },
    visiblepopover() {
      if (this.visiblepopover && this.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        setTimeout(() => {
          this.visiblepopover = false
        }, 1)
      }
    }
  },
  created() {
    const init = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=ed564f9c0ee383bb453cd76d135c8fee'
      document.body.appendChild(script)
      script.onload = () => {
        resolve()
      }
      script.onerror = () => {
        reject()
      }
    })
    init.then((T) => {
      // this.$refs.childMap.initMapData()
      this.$refs.childMap.load()
    })
  },
  mounted() {
    const userId = this.getUrlParam('userId', window.location.href)
    const params = {uid: userId}
    const token = getToken()
    // 存在token，放行
    if (token) {
      this.initTime()
      this.setPermission(getAuthApi())
    } else {
      // const params1 = JSON.parse(JSON.stringify(params))
      request({method: 'post', url: '/api/client/ucenter/login', params}).then(res => {
        // 获取到token
        if (res.code == 200) {
          this.init(res.data.token, res.data.authApi)
          this.setPermission(res.data.authApi)
        }
      })
    }
  },
  methods: {
    getUrlParam(name, href) {
      if (!href)
        href = window.location.href;
      var reg = new RegExp('(\\?|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = href.match(reg);
      if (r != null) {
        var decode = unescape(decodeURI(r[2]));
        return decode;
      }
      return null;
    },
    init(token, authApi) {
      // setToken(token)
      // setAuthApi(authApi)
      this.initTime()
    },
    setPermission(authApi) {
      this.permission = authApi
      if (this.permission == null) {
        this.permission = []
      }
    },
    initTime() {
      const IPOTrendDate = []
      IPOTrendDate[0] = new Date(2023, 3, 1,0,0,0);
      IPOTrendDate[1] = new Date(2024, 3, 30, 23, 59, 59);
      this.data.IPOTrend.pubTime = IPOTrendDate

      const IDDate = []
      IDDate[0] = new Date(2023, 3, 1,0,0,0);
      IDDate[1] = new Date(2024, 3, 30, 23, 59, 59);
      this.data.industryDynamism.pubTime = IDDate

      this.$refs.searchHead.getCount()
      this.$refs.childMap.initMapData()
      this.$refs.volumeLeft.initVolumeLeft()
      this.$refs.volumeRight.initVolumRight()
      this.columnHotValue()
    },
    columnHotValue() {
      var params = {column: 'INDUSTRY_TAGS', topNum: 1000}
      request({params, method: 'get', url: '/api/client/columnHotValue'}).then(result => {
        this.paramForm.industries = result.data
        this.getIndustryPublicOpinionTrend()
      })
      params = {column: 'MEDIA_COUNTRY', topNum: 1000}
      request({params, method: 'get', url: '/api/client/columnHotValue'}).then(result => {
        this.paramForm.countries = result.data
        this.getIndustryDynamism()
      })
      params = {column: 'COMPANY_TAGS', topNum: 1000}
      request({params, method: 'get', url: '/api/client/columnHotValue'}).then(result => {
        this.paramForm.companies = result.data
      })
    },
    getIndustryPublicOpinionTrend() {
      this.visiblepopover = false
      const data = this.data.IPOTrend
      this.bool.IPOTLoading = true
      request({
        data,
        method: 'post',
        url: '/api/client/chinaEnterprise/industryPublicOpinionTrend'
      }).then(result => {
        this.bool.IPOTLoading = false
        const dates = JSON.parse(JSON.stringify(result.data.dates))
        const industries = JSON.parse(JSON.stringify(result.data.industries))
        const lineData = []
        for (let i = 0; i < result.data.list.length; i++) {
          const industryData = []
          for (let j = 0; j < dates.length; j++) {
            let bean = [dates[j], 0]
            if (result.data.list[i][dates[j]] !== undefined) {
              bean = [dates[j], result.data.list[i][dates[j]]]
            }
            industryData.push(bean)
          }
          lineData.push(industryData)
        }
        this.result.IPOTrend.dates = dates
        this.result.IPOTrend.lineData = lineData
        this.result.IPOTrend.industries = industries
        this.$refs.elementViewChild.drawLine()
        const tableData = []
        for (let i = 0; i < result.data.list.length; i++) {
          const bean = {industry: result.data.industries[i]}
          for (let j = 0; j < dates.length; j++) {
            bean[dates[j]] = 0
            if (result.data.list[i][dates[j]] !== undefined) {
              bean[dates[j]] = result.data.list[i][dates[j]]
            }
          }
          tableData.push(bean)
        }
        this.result.IPOTrend.tableData = tableData
      }).catch(result => {
        this.$message.error('Industry public opinion trend failed')
        this.bool.IPOTLoading = false
      })
    },
    getIndustryDynamism() {
      this.visiblepopover = false
      const data = this.data.industryDynamism
      this.bool.IDLoading = true
      request({data, method: 'post', url: '/api/client/chinaEnterprise/industryDynamism?size=10'}).then(result => {
        this.bool.IDLoading = false
        this.result.industryDynamism.lineData.countries = JSON.parse(JSON.stringify(result.data.countries))
        const lineData = []
        if (!result.data.lineData || !result.data.lineData.categoryMap) {
          return
        }
        const lineDataTmp = result.data.lineData.categoryMap
        for (const key in lineDataTmp) {
          const bean = []
          bean.push(key)
          bean.push(lineDataTmp[key])
          lineData.push(bean)
        }
        this.result.industryDynamism.lineData.lineData = lineData
        this.$refs.elementView1Child.drawLine()
        this.result.industryDynamism.pieData.countries = JSON.parse(JSON.stringify(result.data.countries))
        this.result.industryDynamism.pieData.pieData = result.data.pieData
        this.result.industryDynamism.pieData.checkedCountry = this.result.industryDynamism.lineData.countries[0]
        const tableData = []
        const industries = new Set()
        for (let i = 0; i < result.data.pieData.length; i++) {
          const tmp = result.data.pieData[i]
          for (const tmpKey in tmp) {
            industries.add(tmpKey)
          }
        }
        this.result.industryDynamism.table.industries = industries
        for (let i = 0; i < result.data.countries.length; i++) {
          const bean = {country: result.data.countries[i], dynamism: 0}
          if (result.data.lineData.categoryMap[bean.country] !== undefined) {
            bean.dynamism = result.data.lineData.categoryMap[bean.country]
          }
          industries.forEach(industry => {
            bean[industry] = '0/0%'
            if (result.data.pieData[i][industry] !== undefined) {
              const value = result.data.pieData[i][industry]
              const proportion = bean.dynamism === 0 ? 0 : value / bean.dynamism
              bean[industry] = value + '/' + (proportion * 100).toFixed(0) + '%'
            }
          })
          tableData.push(bean)
        }
        this.result.industryDynamism.table.tableData = tableData
      }).catch(result => {
        this.$message.error('industry dynamism failed')
        this.bool.IDLoading = false
      })
    },
    downLoadIPOT() {
      if (this.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      html2canvas(this.$refs[this.bool.isIPOTChart ? 'IPOTChart' : 'IPOTTable']).then(canvas => {
        const imgUrl = canvas.toDataURL('image/png')
        const creatDom = document.createElement('a')
        document.body.appendChild(creatDom)
        creatDom.href = imgUrl
        creatDom.download = 'Industry public opinion trend.png'
        creatDom.click()
      })
    },
    downLoadID() {
      if (this.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        this.visiblepopoversec = false
        return
      }
      html2canvas(this.$refs[this.bool.isIDChart ? 'IDChart' : 'IDTable']).then(canvas => {
        const imgUrl = canvas.toDataURL('image/png')
        const creatDom = document.createElement('a')
        document.body.appendChild(creatDom)
        creatDom.href = imgUrl
        creatDom.download = 'Industry dynamism.png'
        creatDom.click()
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.content {
  //padding: 20px 16px;
  box-sizing: border-box;
  background: #ffffff;
}

.contentExceptFir {
  margin-top: 30px;
}

.contentLast {
  margin-bottom: 100px;
}

.contentSecPart {
  display: flex;
}

.contentSecPart .contentExceptFir ::v-deep .el-table__body-wrapper {
  //height: 380px;
}

#app .mapCard ::v-deep .el-card__body, .el-main {
  padding: 25px 25px;
}

.tarGeta {
  display: flex;
  align-items: center;
  height: 36px;
  padding: 0 15px;
}

.volumeLeftShow {
  width: 100%;
  //height: 530px;
}

.volumeRightShow {
  width: 100%;
  //height: 530px;
}

.volumeLeftRight {
  width: 42%;
}

.volumeRightLeft {
  width: 56%;
  margin-left: 2%;
}

.switch {
  margin-left: auto;
  display: flex;
}

.switch .el-button {
  padding: 0;
  border: none;
}

.el-icon-picture-outline,
.el-icon-s-grid,
.el-icon-download {
  font-size: 25px;
  cursor: pointer;
}

.el-icon-s-grid {
  margin-right: 30px;
}

.el-icon-download {
  margin-right: 10px;
  color: #409eff;
}

.el-icon-picture-outline,
.el-icon-s-grid {
  color: #409eff;
  background: #fff;
  border: 1px solid #ccc;
}

.switchSelected {
  color: #fff;
  background: #409eff;
}

.btnSearch {
  display: inline-block;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.btnSearch img {
  width: 25px;
  height: 25px;
}

.popoverSelectGroup {
  display: flex;
  align-items: center;
  font-size: 11px;
  margin: 20px 20px 0;
}

.industry-chart-button {
  text-align: right;
  margin-top: 40px
}

.charts-margin {
  margin-top: 20px;
}

.charts-table {
  overflow: auto;
  height: 100%;
  margin-left: 15px;
}

.dynamism-button {
  text-align: right;
  margin-top: 40px
}

.dynamism-charts {
  margin-top: 20px;
  padding: 0 15px;
}

.popoverSelect {
  width: 230px !important;
  margin-left: auto;
  border-radius: 15px;
  border: 1px solid #409eff;
}

.popoverSelect ::v-deep .el-input__inner {
  border-radius: 15px;
  border: none;
}

.popoverLine {
  width: 100%;
  height: 4px;
  background: #409eff;
  position: absolute;
  top: 0;
  left: 0;
}

.enterprise span {
  font-size: 14px;
  font-family: "Arial Normal", "Arial", serif;
  color: #666;
}

.seaTar {
  font-weight: 700;
  font-size: 18px;
  color: #389afe;
}

.seaTar1 {
  font-size: 12px;
  color: #ccc;
  margin-left: 50px;
}

.content ::v-deep .el-button--info {
  background-color: #d7d7d7;
  color: #737373;
}

.downloadTable {
  display: table-cell;

  .el-table {
    display: table-cell;

    .el-table__header-wrapper {
      display: table-cell;
    }

    .el-table__body-wrapper {
      display: table-cell;
    }
  }
}
</style>
<style>
.popoverStyle > .popper__arrow::after {
  border-bottom-color: #409eff !important;
}
</style>
